// extracted by mini-css-extract-plugin
export default {"UserWithAvatar":"styles_UserWithAvatar__xvifq","avatar":"styles_avatar__mlQHS","name":"styles_name__NPo-+"};